import React from 'react';
import type createPermissionChecker from '../services/create-permission-checker';

export const PermissionContext = React.createContext<ReturnType<typeof createPermissionChecker>>(
  null!,
);
